/* eslint-disable import/no-unresolved */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Slider from "react-multi-carousel";
import * as Actions from "actions";
import {Box, Container, Grid} from "@mui/material";

import MockProductBox from "components/elements/main/MockProductBox";
import CustomSectionCreator from "components/CustomSectionCreator";
import {Pace} from "components/Atoms";
import AdminShopSalesLogItem from "../AdminShopSalesLogItem";
import AdminShopSupportTicketItem from "../AdminShopSupportTicketItem";

const AdminShopSalesLogList = (props) => {

  const { adminGetShopSalesLog, adminGetShopSupportTickets, shopId, isLoading, saleslogs, supporttickets } = props;

    useEffect(() => {
        adminGetShopSalesLog(shopId);
        adminGetShopSupportTickets(shopId);
    }, []);

    const renderResults = () => (
        <Container>
            <Box mt={4}>
                {isLoading && <Pace color="#27ae60" height="2px" />}
                {<CustomSectionCreator isSubtle={true} title="Recent Sales Logs" /> }
                {saleslogs && saleslogs.map((saleslog, index) => (
                    <AdminShopSalesLogItem saleslog={saleslog} />
                ))}
            </Box>

            <Box mt={4}>
                {isLoading && <Pace color="#27ae60" height="2px" />}
                {<CustomSectionCreator isSubtle={true} title="Recent Support Tickets" /> }
                {supporttickets && supporttickets.map((supportticket, index) => (
                    <AdminShopSupportTicketItem supportticket={supportticket} />
                ))}
            </Box>
        </Container>
    );

  return (
      <>
      {isLoading ? <MockProductBox />
              : saleslogs.length > 0
                  ? renderResults()
                  : ""}


      </>
  );
};

AdminShopSalesLogList.propTypes = {
    searchkeywords: PropTypes.objectOf(PropTypes.any).isRequired,
    adminSearchShopKeywords: PropTypes.func.isRequired,
};

// Mapping Props and State.
const adminShopSalesLogList = connect(
  ({ adminShops, bootupInfo }) => ({
      userDetails: bootupInfo.userDetails,
      reqStatus: adminShops.reqStatus,
      isLoading: adminShops.isLoading,
      serviceError: adminShops.serviceError,
      saleslogs: adminShops.saleslogs,
      supporttickets: adminShops.supporttickets,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(AdminShopSalesLogList);

export { adminShopSalesLogList as default };
